<app-navbar title="Rozkład">
	<a class="btn btn-primary me-4" routerLink="/tourism-transport-list-confirmations/{{ timetableId }}">
		<i class="fas fa-clipboard-check"></i> Potwierdzenia
	</a>
	<a class="btn btn-primary me-4" routerLink="/tourism-transport-list/{{ timetableId }}">
		<i class="fas fa-list"></i> Listy
	</a>
	<a class="btn btn-primary me-4" routerLink="/tourism-map/{{ timetableId }}">
		<i class="fas fa-map-marked-alt"></i> Mapa
	</a>
	<a class="btn btn-primary me-4" routerLink="/tourism-timetable/{{ timetableId }}">
		<i class="far fa-clock"></i> Godziny
	</a>
	<button class="btn btn-danger me-4" (click)="deleteAsk()"><i class="far fa-trash-alt"></i> Usuń</button>
</app-navbar>

<div class="container">
	<ol class="breadcrumb">
		<li class="breadcrumb-item fw-bolder">{{ sideName }}</li>
		<li class="breadcrumb-item" *ngFor="let item of data?.seasons">
			{{ item.destinationName }}
			<span *ngIf="data.side === 'departure'">({{ item.departureDate }} {{ item.accommodationFrom }})</span>
			<span *ngIf="data.side === 'return'"
				>({{ item.departureFromDestination }} {{ item.arrivalToLastStop }})</span
			>
		</li>
	</ol>

	<p>Status: {{ statusName }} -<button type="button" class="btn btn-link" (click)="approveAsk()">Zmień</button></p>
</div>
